import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import TabView, { Tab } from '../../components/TabView';
import Strings from '../../Strings';
import Configuration from './Configuration/Configuration';
import ExternalApiOauth from '../SuperUser/ExternalApi/ExternalApiOauth';
import ExternalApiAccessControl from '../SuperUser/ExternalApi/ExternalApiAccessControl';
import { DOCTOR, ORGANIZATION_MANAGER, CAP_MANAGER, isSuperUser } from '../../utils/userRoles';
import ExternalApiLogs from '../SuperUser/ExternalApi/ExternalApiLogs';
import OrgStateHistory from './OrgStateHistory';
import { hasPermission, PERMISSIONS } from '../../utils/userPermissions';
import CareProviderApi from '../SuperUser/ExternalApi/CareProviderApi';
import UserList from '../Users/UserList';
import OrgSamlConfiguration from '../SuperUser/Saml/OrgSamlConfiguration';
import AthenaConfiguration from '../SuperUser/Athena/AthenaConfiguration';
import ClinicianRosterConfiguration from '../SuperUser/ClinicianRoster/ClinicianRosterConfiguration';

class ManageOrganization extends PureComponent {

  render() {
    const { match: { params: { id: orgId, name } } } = this.props;
    const { activeTab } = this.props;
    const tabArray = [];

    if (hasPermission(PERMISSIONS.ORGANIZATION_ORG_MANAGER_VIEW)) {
      tabArray.push(
        <Tab name={Strings.organizationManagers} path={`/admin/organizations/${orgId}/${name}/organization-manager`} key="org-manager">
          <UserList organizationId={orgId} role={ORGANIZATION_MANAGER} organizationName={name} />
        </Tab>,
      );
    }

    if (hasPermission(PERMISSIONS.ORGANIZATION_CAPMANAGER_VIEW)) {
      tabArray.push(
        <Tab name={Strings.capManager} path={`/admin/organizations/${orgId}/${name}/cap-manager`} key="cap-manager">
          <UserList organizationId={orgId} role={CAP_MANAGER} organizationName={name} />
        </Tab>,
      );
    }

    if (hasPermission(PERMISSIONS.ORGANIZATION_ADMIN_VIEW)) {
      tabArray.push(
        <Tab name={Strings.adminTab} path={`/admin/organizations/${orgId}/${name}/admin`} key="admin">
          <UserList organizationId={orgId} role={DOCTOR} organizationName={name} />
        </Tab>,
      );
    }
    if (hasPermission(PERMISSIONS.ORGANIZATION_MANAGEMENT) || isSuperUser()) {
      tabArray.push(
        <Tab name={Strings.configuration} path={`/admin/organizations/${orgId}/${name}/config`} key="configuration">
          <Configuration organizationId={orgId} organizationName={name} />
        </Tab>,
      );
    }
      tabArray.push(
        <Tab name={Strings.stateHistory} path={`/admin/organizations/${orgId}/${name}/state-history`} key="state-history">
          <OrgStateHistory organizationId={orgId} organizationName={name} />
        </Tab>,
      );

      if (hasPermission(PERMISSIONS.ORGANIZATION_EXTERNAL_API_OAUTH)) {
        tabArray.push(
          <Tab name={Strings.externalApiOauthTab} path={`/admin/organizations/${orgId}/${name}/external-api/oauth`} key="external-api-oauth">
            <ExternalApiOauth organizationId={orgId} organizationName={name} />
          </Tab>,
        );
      }

      if (hasPermission(PERMISSIONS.ORGANIZATION_EXTERNAL_API_ACCESS_CONTROL)) {
        tabArray.push(
          <Tab name={Strings.externalApiAccessControlTab} path={`/admin/organizations/${orgId}/${name}/external-api/access-control`} key="external-api-access-control">
            <ExternalApiAccessControl organizationId={orgId} organizationName={name} />
          </Tab>,
        );
      }

      if (hasPermission(PERMISSIONS.ORGANIZATION_EXTERNAL_API_LOGS)) {
        tabArray.push(
          <Tab name={Strings.externalApiLogsTab} path={`/admin/organizations/${orgId}/${name}/external-api/logs`} key="external-api-logs">
            <ExternalApiLogs organizationId={orgId} organizationName={name} />
          </Tab>,
        );
      }
      if (hasPermission(PERMISSIONS.ORGANIZATION_CARE_PROVIDER_API)) {
        tabArray.push(
          <Tab name={Strings.careProviderApiTab} path={`/admin/organizations/${orgId}/${name}/care-provider-api`} key="care-provider-api">
            <CareProviderApi organizationId={orgId} organizationName={name} />
          </Tab>,
        )
      }

      if (isSuperUser()) {
        tabArray.push(
          <Tab name={Strings.athenaConfigurationTab} path={`/admin/organizations/${orgId}/${name}/athena`} key="athena-configuration">
            <AthenaConfiguration organizationId={orgId} organizationName={name} />
          </Tab>,
          <Tab name={Strings.accessClinicianRosterTab} path={`/admin/organizations/${orgId}/${name}/access-clinician-roster`} key="access-clinician-roster">
            <ClinicianRosterConfiguration organizationId={orgId} organizationName={name} />
          </Tab>,
        );
      }

      if (hasPermission(PERMISSIONS.ORGANIZATION_EXTERNAL_API_ACCESS_CONTROL)) {
        tabArray.push(
          <Tab name={Strings.samlConfigurationTab} path={`/admin/organizations/${orgId}/${name}/saml`} key="saml-configuration">
            <OrgSamlConfiguration organizationId={orgId} organizationName={name} />
          </Tab>,
        );
      }

    return (
      <TabView key="tabs" activeTab={activeTab} routeMode className="">
        {tabArray}
      </TabView>
    );
  }
}

ManageOrganization.propTypes = {
  activeTab: PropTypes.any,
  caps: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.string,
      type: PropTypes.any,
    }),
  }),
  onNavigate: PropTypes.func,
  onSet: PropTypes.func,
};

const mapStateToProps = state => {
  return { role: state.auth.role };
};

const mapDispatchToProps = dispatch => ({ onNavigate: path => dispatch(push(path)) });

export default connect(mapStateToProps, mapDispatchToProps)(ManageOrganization);
